module.exports = __webpack_public_path__ + "img/send.18da43f3.png";